import {useMemo} from 'react'
import WelcomeHome from "@/customComponents/homeComponents/WelcomeHome.jsx"
import UpcomingRide from "@/customComponents/homeComponents/UpcomingRide.jsx"
import PaymentMethods from "@/customComponents/homeComponents/PaymentMethods.jsx"
import BookingHistory from "@/customComponents/homeComponents/BookingHistory.jsx"
import {useUpcomingTrips} from '@/hooks/useTrips'

function Home() {
    const {data, isLoading} = useUpcomingTrips({page: 1, perPage: 5})
    const trip = useMemo(
        () => data?.trips?.find(t => t.status !== 'Requested' && t.status !== 'Draft'),
        [data?.trips]
    )
    const hasTrip = isLoading || !!trip

    return (
        <div className="flex flex-col gap-5 min-w-0">
            <WelcomeHome />
            <div className="grid grid-cols-12 gap-5">
                <div className={`col-span-12 ${hasTrip ? 'lg:col-span-9' : ''} min-w-0`}>
                    <UpcomingRide />
                </div>
                {hasTrip && (
                    <div className="col-span-12 lg:col-span-3 max-md:hidden min-w-0">
                        <PaymentMethods />
                    </div>
                )}
            </div>
            <BookingHistory />
        </div>
    )
}

export default Home
